"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.u0033 = void 0;
var u0033 = {
  "viewBox": "0 0 2600 2760.837",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1438 1378v8q243 30 369 154t126 323q0 278-190 437.5T1197 2460q-149 0-281-23.5T667 2352v-233q119 63 258 97t267 34q236 0 360.5-98t124.5-297q0-174-131-264t-391-90H973v-207h182q217 0 338.5-103.5T1615 915q0-141-94-222t-248-81q-148 0-259.5 46.5T801 778L675 606q120-97 275-151t323-54q281 0 439.5 135T1871 898q0 190-113 317t-320 163z"
    },
    "children": []
  }]
};
exports.u0033 = u0033;